// The full site is served via public/index.html (static HTML landing page)
// React is present only for the build pipeline; App renders nothing.

function App() {
  return null;
}

export default App;
